module.exports = __webpack_public_path__ + "img/rightIcon.ffcdc7ef.svg";